import React from "react";
var __jsx = React.createElement;
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowSearchBar from "@/pages/sell-my-car/components/FlowSearchBar";
import { useTranslation } from "@i18n";
import { useCallback, useState } from "react";
import FlowScreenHeaderSpacing from "@/pages/sell-my-car/components/FlowScreenHeaderSpacing";
import FlowScreenBodySpacing from "@/pages/sell-my-car/components/FlowScreenBodySpacing";
import { useLang } from "@/common/Contexts/LanguageContext";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowZeroResult from "@/pages/sell-my-car/components/FlowZeroResult";
import { If } from "@componentsShared/Conditional/If";
import useBoolean from "@hooks/useBoolean";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
var CarYearScreen = function CarYearScreen() {
  var _state$years;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    actions = _useSellCarData.actions,
    state = _useSellCarData.state;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState([]),
    filteredYears = _useState[0],
    setFilteredYears = _useState[1];
  var _useState2 = useState(null),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var lang = useLang();
  var loading = useBoolean(true);
  var handleYearSelect = function handleYearSelect(year) {
    actions.selectYear(year);
    navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_ODOMETER);
  };
  var searchYearsWrapper = useCallback(function (_items, searchTerm, limit) {
    setSearchTerm(searchTerm);
    return actions.searchYear(searchTerm, limit);
  }, [actions.searchYear]);
  var handleSearchResults = useCallback(function (results) {
    setFilteredYears(results);
    setTimeout(function () {
      loading.setFalse();
    }, 300);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-year-screen",
    className: "flex flex-col h-full md:pb-6"
  }, /*#__PURE__*/React.createElement(FlowScreenHeaderSpacing, null, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_year", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(If, {
    condition: ((_state$years = state.years) === null || _state$years === void 0 ? void 0 : _state$years.length) > 8
  }, /*#__PURE__*/React.createElement(FlowSearchBar, {
    options: state.years,
    searchFunction: searchYearsWrapper,
    onSearch: handleSearchResults,
    onSelect: handleYearSelect,
    limit: 100,
    getItemKey: function getItemKey(year) {
      return year;
    },
    placeholder: tShort("sell_trade_v2/search_brands_placeholder", {
      ns: "web_sell_trade"
    }),
    showResults: false,
    id: "year-search",
    type: "tel",
    inputMode: "numeric",
    pattern: "[0-9]*",
    dir: lang == 'ar' ? 'rtl' : "ltr"
  }))), /*#__PURE__*/React.createElement(FlowScreenBodySpacing, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, {
    className: "md:h-[58px]"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (filteredYears === null || filteredYears === void 0 ? void 0 : filteredYears.length) !== 0
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-year-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-5 md:gap-8",
    dir: lang == 'ar' ? "rtl" : "ltr"
  }, filteredYears === null || filteredYears === void 0 ? void 0 : filteredYears.map(function (year) {
    return /*#__PURE__*/React.createElement(FlowOption, {
      key: year,
      id: "sell-car-year-option-".concat(year),
      onClick: function onClick() {
        return handleYearSelect(year);
      }
    }, /*#__PURE__*/React.createElement(FlowOptionBody, {
      name: year.toString(),
      haveBackground: false
    }));
  }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: filteredYears !== null && searchTerm !== null
  }, /*#__PURE__*/React.createElement(FlowZeroResult, {
    searchTerm: searchTerm
  }))))))));
};
export default CarYearScreen;